import React, { useMemo } from 'react';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ColumnDirective, ColumnsDirective, Filter, GridComponent, Group } from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button } from '@material-ui/core';
import { dateTemplate } from 'routes/Pages/GenTask/components/SharedFormFields';

const ViewStockTransactions = ({ viewTransactionDialog, handleDialogClose, stockTransaction }) => {
  const toolbarOptions = [{ text: 'Search', tooltipText: 'Search', prefixIcon: 'e-search', id: 'search' }];

  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );
  const filterSettings = {
    type: 'Excel',
  };

  if (!stockTransaction) {
    return <CircularProgress />;
  }

  return (
    <div>
      {/* <Dialog open={viewTransactionDialog} onClose={handleDialogClose} maxWidth="xl" fullWidth scroll="paper">
        <DialogTitle>Stock Transactions</DialogTitle>
        <DialogContent dividers> */}
      <GridComponent
        dataSource={stockTransaction}
        filterSettings={filterSettings}
        allowPaging={true}
        pageSettings={pageSettings}
        allowSorting={true}
        allowTextWrap={true}
        allowResizing={true}
        allowMultiSorting={true}
        allowReordering={true}
        allowFiltering={true}
        height="400px"
        toolbar={toolbarOptions}>
        <ColumnsDirective>
          {/* <ColumnDirective
                                    field="id"
                                    headerText="View Details"
                                    width="80"
                                    textAlign="Left"
                                    isPrimaryKey={true}
                                    template={editLinkTemplate}
                                /> */}
          <ColumnDirective field="pO_ReqNumber" headerText="Order Number" width="100" />
          <ColumnDirective field="stock" headerText="Stock" width="100" />
          <ColumnDirective field="departmentOrMachine" headerText="Department" width="100" />
          <ColumnDirective field="quantity" headerText="Quantity" width="100" />
          <ColumnDirective field="transactionType" headerText="Transaction Type" width="120" />
          <ColumnDirective
            field="transactionDate"
            headerText="Transaction Date"
            width="100"
            type={'datetime'}
            formatter={dateTemplate}
          />
          <ColumnDirective field="recordEnteredBy" headerText="Recorded By" width="100" />
          <ColumnDirective
            field="recordModifiedDate"
            headerText="Modified Date"
            width="80"
            textAlign="Right"
            type={'datetime'}
            formatter={dateTemplate}
          />
        </ColumnsDirective>
        <Inject services={[Page, Sort, Filter, Group, Search, Toolbar]} />
      </GridComponent>
      {/* </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog> */}
    </div>
  );
};

export default ViewStockTransactions;
